/**
 * The message an admin sends a client's new portal login, ready to paste into
 * an email or text. No imports and only erasable types, so node --test loads
 * this file directly (test/portal-invite.test.js).
 */
export type Invite = { email: string; password: string; created: boolean; name: string; clientName: string };

/** A message ready to paste into an email or text: who it is for, what the portal does, how to sign in. */
export function inviteText({ email, password, created, name, clientName }: Invite, origin: string): string {
  const first = name.trim().split(/\s+/)[0] || "there";
  // Clients sign in on the client page, as the dialog, setup emails and member invites say.
  const signIn = `${origin}/client-login`;
  const opening = created
    ? `Hi ${first}, here is your login for the ${clientName} client portal. You can see your results and reports there, and send us a new task or question any time without emailing.`
    : `Hi ${first}, here is a new password for the ${clientName} client portal.`;
  return `${opening}\n\nSign in at ${signIn}\nEmail: ${email}\nTemporary password: ${password}\n\nPlease change the password after you sign in (Settings, then Account & security, then Change password).`;
}

